import { DOCUMENT_CONTROL_PANEL_HEIGHT } from 'constants/documents';
import { checkIsLightTheme } from 'utils/theme';

export const getStyles = (theme, { additionalHeaderHeight } = {}) => {
  return {
    controlPanelWrapper: {
      backgroundColor: checkIsLightTheme(theme.palette.type)
        ? theme.palette.grey['400']
        : theme.palette.grey['700'],
      borderRadius: '10px 10px 0 0',
      paddingBottom: '10px',
    },
    documentView: {
      flex: 1,
      maxHeight: `calc(100% - ${DOCUMENT_CONTROL_PANEL_HEIGHT}px - ${additionalHeaderHeight}px)`,
      padding: '10px 30px',

      '& > *': {
        marginBottom: '5px',
        display: 'inline-flex',
        justifyContent: 'center',
      },
    },
    documentViewContainer: {
      width: '100%',
      overflow: 'hidden',
      paddingBottom: '30px',
    },
  };
};
